import {
  fetchTinkReports,
  finishTinkConnection,
  getTinkAccountCheckLink,
  getTinkConnections,
} from '@/api/integrations'
import {
  BankingIntegrationConfig,
  BankingReports,
} from '@/pages/Profile/components'
import { useInvalidateOnSuccessMutation } from '@/utils'
import { useQuery, UseQueryOptions } from 'react-query'

const keys = {
  tinkIntegrationLink: 'tinkIntegrationLink',
  tinkReports: 'tinkReports',
  tinkConnections: 'tinkConnections',
}

export const useGetTinkConnections = () =>
  useQuery(keys.tinkConnections, getTinkConnections)

export const useTinkIntegrationLink = (config: BankingIntegrationConfig) =>
  useInvalidateOnSuccessMutation(keys.tinkIntegrationLink, () =>
    getTinkAccountCheckLink(config),
  )

export const useRetrieveTinkReports = (
  options: UseQueryOptions<BankingReports>,
) => useQuery<BankingReports>(keys.tinkReports, fetchTinkReports, options)

export const useFinishTinkConnection = () =>
  useInvalidateOnSuccessMutation<void, unknown, void, unknown>(
    [keys.tinkIntegrationLink, keys.tinkReports, keys.tinkConnections],
    finishTinkConnection,
  )
